import React, { useState } from "react";
import { Fade } from "reactstrap";
import "./lightbox.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

  const Lightbox = ({ id = "lightbox", onClose = () => { }, children }) => {
  const [fadeIn,] = useState(true);  

  return (
      <Fade id={id} in={fadeIn} className="lightbox">
        <div className="lightbody">          
        <FontAwesomeIcon icon={faTimes} onClick={onClose} className="closeLightbox transition-slow" size="3x" />
            {children}                   
        </div>
      </Fade>
  );
};
export default Lightbox;
